import { Navigate } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";

const RedirectToDashboard = () => {
  const { isSubadmin, isSubSubAdmin } = useAuth();

  if (isSubSubAdmin) return <Navigate to="/subsubadmin/dashboard" replace />;
  if (isSubadmin) return <Navigate to="/subadmin/dashboard" replace />;

  return <Navigate to="/" replace />;
};

export default RedirectToDashboard;
